module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_7005.d19b16aa.png";